import { schemes, zSchema } from "@zeal/common";

const postCustomPayrollJournalFieldsSchema = zSchema.object({
  disbursement: zSchema.boolean(),
  earnings: zSchema.boolean(),
  employee_taxes: zSchema.boolean(),
  employer_check_id: zSchema.boolean(),
  employer_taxes: zSchema.boolean(),
  gross_pay: zSchema.boolean(),
  net_pay: zSchema.boolean(),
});

export const postCustomPayrollJournalRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  customer_account_ids: zSchema.array(zSchema.string()),
  start_date: zSchema.string(),
  end_date: zSchema.string(),
  media_type: zSchema.string(),
  fields: postCustomPayrollJournalFieldsSchema,
  custom_attributes: zSchema.record(zSchema.string(), zSchema.any()),
});

export type TPostCustomPayrollJournalRequestSchema = zSchema.infer<
  typeof postCustomPayrollJournalRequestSchema
>;
